export const handleAdd = ({ rowId, corrosionLoopId, subjects, row, type, site, shortname, cmlId, updateSubjectsIndex, updateSubjects, subjectIndex, analysisData }) => {

    let duplicate = false;
    for (let i = 0; i < subjects.length; i++) {
        if (row === subjects[i].name) {
            duplicate = true;
        }
    }
    let updatedRows = [];
    if (duplicate === false) {
        updateSubjectsIndex((previousState) => previousState + 1);
        if (subjects === undefined) {
            updatedRows = [subjects];
        } else if (subjects.length > -1) {
            updatedRows = [...subjects];
        }
        updatedRows[subjectIndex] = {
            rowId: rowId,
            index: subjectIndex,
            type: type,
            name: row,
            site: site,
            shortname: shortname,
            corrosionLoopId: corrosionLoopId,
            cmlId: cmlId
        };
        let cmlSensorAdded = [];
        if (type === 'Corrosion Loop') {
            const clList = analysisData?.analysisList?.filter(obj => obj?.corrosionLoop === row);
            const cmlData = clList?.map(item => ({ cmlRowId: item.id, id: item.cmlId, shortname: `${item.equipment} ${item.cmlName}` })) // Keep the shortname here
                .filter(({ id }, index, self) => self.findIndex(item => item.id === id) === index) // Use id for filtering
                .filter(({ id }) => {
                    if (subjects.filter(a => a.name === id).length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                }).map(({ cmlRowId, id, shortname }, index) => { // Use both id and shortname here
                    updateSubjectsIndex((previousState) => previousState + 1);
                    return {
                        rowId: cmlRowId,
                        index: subjectIndex + (index + 1),
                        type: 'Condition Monitoring Location',
                        name: id,
                        shortname: shortname, // Include shortname in the new object
                        site: site,
                        corrosionLoopId: corrosionLoopId
                    };
                });
            let sensorData = [];
            if (site === 'BON') {
                sensorData = clList?.map(item => ({ id: item.id, cmlId: item.cmlId }))
                    .filter((value, index, self) => self.indexOf(value) === index).filter(x => {
                        if (subjects.filter(a => a.name === x).length > 0) {
                            return false;
                        } else {
                            return true;
                        }
                    }).map((ele, index) => {
                        updateSubjectsIndex((previousState) => previousState + 1);
                        return {
                            rowId: ele.id,
                            index: subjectIndex + (index + 1) + (cmlData?.length),
                            type: 'Sensor',
                            name: ele.id,
                            site: site,
                            corrosionLoopId: corrosionLoopId,
                            cmlId: ele.cmlId
                        };
                    })
            }
            cmlSensorAdded = [...cmlData, ...sensorData];
        }

        let sensorData = [];
        if (type === 'Condition Monitoring Location' && site === 'BON') {
            const clList = analysisData?.analysisList?.filter(obj => obj?.cmlId === row);
            sensorData = clList?.map(item => item.id)
                .filter((value, index, self) => self.indexOf(value) === index).filter(x => {
                    if (subjects.filter(a => a.name === x).length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                }).map((ele, index) => {
                    updateSubjectsIndex((previousState) => previousState + 1);
                    return {
                        rowId: ele,
                        index: subjectIndex + (index + 1),
                        type: 'Sensor',
                        name: ele,
                        site: site,
                        corrosionLoopId: corrosionLoopId,
                        cmlId: row
                    };
                })

        }
        updateSubjects([...updatedRows, ...cmlSensorAdded, ...sensorData]);
    }
};

export const handleClear = ({ subjects, id, type, site, updateSubjectsIndex, updateSubjects }) => {

    updateSubjectsIndex((previousState) => previousState - 1);
    if (subjects.length > 0) {
        let updatedRows = [...subjects];
        // Remove the CL by id and type
        const indexToRemove = updatedRows.findIndex((x) => x.name === id && x.type === type);
        if (indexToRemove > -1) {
            updatedRows.splice(indexToRemove, 1);
        }


        // Remove associated CMLs by checking corrosionLoopId
        updatedRows = updatedRows.filter(ele => !(ele.type === "Condition Monitoring Location" && ele.corrosionLoopId === id));

        if (site === 'BON') {
            // Remove associated Sensors by checking corrosionLoopId
            updatedRows = updatedRows.filter(ele => !(ele.type === "Sensor" && ele.corrosionLoopId === id));

            if (type === 'Condition Monitoring Location') {
                // Remove associated Sensors by checking corrosionLoopId
                updatedRows = updatedRows.filter(ele => !(ele.type === "Sensor" && ele.cmlId === id));
            }
        }

        // Update subjects with the filtered list
        updateSubjects(updatedRows);
        // Update subjects index based on the new length
        updateSubjectsIndex(updatedRows.length);
    }
};